import { render, staticRenderFns } from "./VisaoGeral.vue?vue&type=template&id=b7674400&"
import script from "./VisaoGeral.vue?vue&type=script&lang=js&"
export * from "./VisaoGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports